var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-checkbox-group',{staticClass:"aj-checkbox",class:_vm.wrap ? '' : 'aj-checkbox-nowrap',style:({
    '--bgColor': _vm.bgColor,
    '--textColor': _vm.textColor,
    '--bgColorActive': _vm.bgColorActive,
    '--textColorActive': _vm.textColorActive
  }),attrs:{"direction":"horizontal"},model:{value:(_vm.checkValue),callback:function ($$v) {_vm.checkValue=$$v},expression:"checkValue"}},_vm._l((_vm.checkList),function(item){return _c('van-checkbox',{key:item[_vm.props.value],attrs:{"name":item[_vm.props.value]}},[_vm._v(_vm._s(item[_vm.props.label]))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }